import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, patch } from "@insite/client-framework/Services/ApiService";

export interface GetRMAStatusParamater {
    orderSearchType?: string; // ---optional P21 Change
    pO: string | null;
    status: string;
    fromDate: string;
    toDate: string;
    selectedPage: number;
    sortBy: string;
    sortOrder: string | null;
    currentPageSize: string;
    properties: [];
}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: any;
    sortType: any;
    nextPageUri: string;
    prevPageUri: any;
}

export interface AddRMAStatusResultModel {
    adonisMessage: string;
    orders: ordersData[];
    pagination: Pagination;
    properties: {};
    searchFilter: string;
    uri: string;
}

export interface ordersData {
    rowID: any;
    id: string;
    rmaReturnID: string;
    webOrderNumber: string;
    erpOrderNumber: any;
    customerPO: string;
    rmaStatus: any;
    statusDisplay: string;
    orderDate: string;
    orderTime: string;
    tracking: string;
}

const url = "/api/v1/returns/searchReturnOrders";

export async function updateRMAStatus(
    parameter: GetRMAStatusParamater,
): Promise<ServiceResult<AddRMAStatusResultModel>> {
    try {
        const resultModel = await patch<AddRMAStatusResultModel>(`${url}`, parameter as any);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
